var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpotScoreChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "307px",
    height: "392px",
    viewBox: "0 0 307 392",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Spot Score makeup") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SPOT-score",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Spot-Score-makeup",
    transform: "translate(5.177480, 4.874084)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(29.977851, 91.144402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.165397,0 C197.396907,0 254.330794,56.9828008 254.330794,127.274648 C254.330794,197.566495 197.396907,254.549296 127.165397,254.549296 C56.9338876,254.549296 0,197.566495 0,127.274648 C0,56.9828008 56.9338876,0 127.165397,0 Z M127.165397,52.0305164 C85.6448821,52.0305164 51.9858542,85.7184616 51.9858542,127.274648 C51.9858542,168.830834 85.6448821,202.518779 127.165397,202.518779 C168.685912,202.518779 202.34494,168.830834 202.34494,127.274648 C202.34494,85.7184616 168.685912,52.0305164 127.165397,52.0305164 Z",
    id: "Combined-Shape",
    fill: "#C6C0C0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.165397,202.518779 C145.73147,202.518779 162.725662,195.78298 175.841492,184.619846 L209.394648,224.363429 C187.223814,243.191956 158.519791,254.549296 127.165397,254.549296 C73.9096936,254.549296 28.3001297,221.784155 9.36281309,175.296327 L57.6494373,155.977835 C68.9217767,183.295155 95.8005549,202.518779 127.165397,202.518779 Z",
    id: "Combined-Shape",
    fill: "#43A9D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.566003,0.000618152165 L127.618035,52.0318516 C127.467261,52.0309619 127.316381,52.0305164 127.165397,52.0305164 C116.742782,52.0305164 106.815541,54.153284 97.7917289,57.9904121 L77.447951,10.094797 C92.7202153,3.59569048 109.523257,0 127.165397,0 L127.566003,0.000618152165 L127.566003,0.000618152165 Z",
    id: "Combined-Shape",
    fill: "#5A98B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.184442,1.39667932e-06 C197.407199,0.0103014714 254.330794,56.9891545 254.330794,127.274648 C254.330794,166.416182 236.677058,201.430924 208.903945,224.77804 L175.504426,184.905036 C191.914755,171.102342 202.34494,150.407592 202.34494,127.274648 C202.34494,85.7766335 168.780081,52.1248473 127.339717,52.0307144 L127.184442,1.39667932e-06 Z",
    id: "Combined-Shape",
    fill: "#01294A"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    d: "M297.105164,127.968319 C299.314303,127.968319 301.105164,129.75918 301.105164,131.968319 C301.105164,134.177458 299.314303,135.968319 297.105164,135.968319 C295.030947,135.968319 293.325476,134.38953 293.124891,132.368092 L269.678,132.368 L257.7989,144.258109 L257.232972,143.692667 L269.229735,131.685597 L269.346913,131.568319 L293.124891,131.568545 C293.325476,129.547107 295.030947,127.968319 297.105164,127.968319 Z",
    fill: "#979797",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    d: "M3.98027235,166.78828 C3.77968731,168.809718 2.07421658,170.388506 4.8985872e-16,170.388506 C-2.209139,170.388506 -4,168.597645 -4,166.388506 C-4,164.179367 -2.209139,162.388506 -4.8985872e-16,162.388506 C2.07421658,162.388506 3.77968731,163.967295 3.98027235,165.988732 L19.25942,165.988506 L19.3617342,166.058763 L35.9978201,177.482434 L35.5449642,178.14192 L19.01,166.788 Z",
    fill: "#979797",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    d: "M74.664737,0.400762036 C74.4636943,2.42172583 72.7584414,4 70.6845628,4 C68.4754238,4 66.6845628,2.209139 66.6845628,4.8985872e-16 C66.6845628,-2.209139 68.4754238,-4 70.6845628,-4 C72.7584414,-4 74.4636943,-2.42172583 74.664737,-0.400762036 L91.5745544,-0.4 L91.6751396,-0.148576152 L128.757027,92.541752 L128.014261,92.8389043 L91.033,0.4 Z",
    fill: "#979797",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    d: "M31.7263095,304.879402 C33.9352908,304.853005 35.7474228,306.62234 35.7738195,308.831321 C35.7985999,310.905045 34.240825,312.62903 32.2224178,312.854216 L32.445,331.629 L72.5231134,381.918997 L71.8974831,382.417582 L31.7348506,332.021018 L31.6493338,331.91371 L31.6476942,331.776505 L31.4229295,312.86397 C29.3987617,312.688026 27.7991793,311.001326 27.7743906,308.926912 C27.7479939,306.717931 29.5173282,304.905799 31.7263095,304.879402 Z",
    transform: "translate(51.992202, 345.523703) scale(1, -1) translate(-51.992202, -345.523703) ",
    fill: "#979797",
    fillRule: "nonzero"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotScoreChart);
export default __webpack_public_path__ + "static/media/SpotScoreChart.d9cb6a0bc4d970d5c8290172823055f7.svg";
export { ForwardRef as ReactComponent };